import {
  collection,
  collectionGroup,
  doc,
  DocumentData,
  getDoc,
  getDocs,
  query,
  QueryDocumentSnapshot,
  where,
} from "firebase/firestore";
import { db } from "../firebase";
import { MessageTimestampToDate, Topic, TopicTimestampToDate } from "../model/Message";
import { EventParticipationHistory } from "../model/EventParticipationHistory";

const messagesQuery = {
  // お知らせ取得
  getMessage: async (messageId: string) => {
    console.log("message getMessage access");
    const messageRef = await getDoc(doc(db, "messages", messageId));
    return MessageTimestampToDate(messageRef.data());
  },
  // お知らせに付加されたTopic取得
  getTopic: async (messageId: string) => {
    console.log("message getTopic access");
    const topicList =  await getDocs(collection(db, `messages/${messageId}/topic`));
    return topicList.docs.map((doc) => TopicTimestampToDate(doc.data()) as Topic);
  },

  // イベント参加履歴取得（返信・出欠データ取得用）
  getEventParticipationHistory: async (
    tenantId: string,
    displayId: string,
    userId: string,
    messageId: string
  ) => {
    console.log("message getEventParticipationHistory access");
    var historyDaya;
    const queries: any[] = [
      where('tenantId', "==", tenantId),
      where('isMunicipalityConfirmed', "==", true),
    ];
    queries.push(where('messageId', "==", messageId));
    queries.push(where('userDisplayId', "==", displayId));

    // 履歴取得
    const eventParticipationHistoryDocsQuery = await getDocs(
      query(
        collectionGroup(db, "eventParticipationHistory"),
        ...queries
      )
    );

    historyDaya = eventParticipationHistoryDocsQuery.docs.map((doc: QueryDocumentSnapshot<DocumentData>) => {
      return (doc.data() as EventParticipationHistory);
    });

    // eventParticipationHistoryにデータがない場合（旧イベント参加履歴）
    if(historyDaya.length == 0){
      // 旧イベント参加履歴取得（readMessagesから取得）
      const queries: any[] = [
        where('userId', '==', userId),
        where('replyButtonName', 'in', ['会場で参加', 'オンラインで参加', '欠席'])
      ];
      queries.push(where('messageId', "==", messageId));
      const readSnapshot = await getDocs(
        query(
          collectionGroup(db, "readMessages"),
          ...queries
        )
      );
      historyDaya = readSnapshot.docs.map((doc: QueryDocumentSnapshot<DocumentData>) => {
        return (doc.data() as EventParticipationHistory);
      });
    }
    return historyDaya[0];
  },

  // イベント参加履歴取得
  getEventParticipationAttendanceHistory: async (
    tenantId: string,
    displayId: string,
    userId: string,
  ) => {
    console.log("message getEventParticipationAttendanceHistory access");

    // イベント参加履歴取得
    const queries: any[] = [
      where('tenantId', "==", tenantId),
      where('userDisplayId', "==", displayId),
      where('isMunicipalityConfirmed', "==", true),
      where('attendanceButtonName', "in", ['会場で参加', 'オンラインで参加', '未回答', '欠席'])
    ];

    const eventParticipationHistoryDocsQuery = await getDocs(
      query(collectionGroup(db, "eventParticipationHistory"), ...queries)
    );

    const histories = eventParticipationHistoryDocsQuery.docs.map((doc) => doc.data() as EventParticipationHistory);

    // 旧イベント参加履歴取得（readMessagesから取得）
    const readSnapshot = await getDocs(
      query(
        collectionGroup(db, 'readMessages'),
        where('userId', '==', userId),
        where('replyButtonName', 'in', ['会場で参加', 'オンラインで参加', '未回答', '欠席'])
      )
    );

    // attendanceButtonNameが存在しないかつmessageIdが重複しないデータのみ
    const existingMessageIds = new Set(histories.map(h => h.messageId));
    const filteredOld = readSnapshot.docs
      .map(doc => doc.data() as EventParticipationHistory)
      .filter(data =>
        data.attendanceButtonName === undefined &&
        !existingMessageIds.has(data.messageId)
      );

    const nowDate = new Date();
    const oldHistories = (await Promise.all(
      filteredOld.map(async (data) => {
        const msgDoc = await getDoc(doc(db, "messages", data.messageId));
        const msgData = msgDoc.exists() ? msgDoc.data() : null;
        // イベント終了時間が現在日時より過去
        const eventEndAt = msgData?.eventEndAt?.toDate?.();
        if (!eventEndAt || eventEndAt > nowDate) return null;
        return {
          ...data,
          title: msgData?.title ?? null,
          eventAt: msgData?.eventAt ?? null,
          attendanceButtonName: data?.replyButtonName ?? null,
        };
      })
    )).filter(Boolean); 

    // 新旧データ統合
    return [...histories, ...oldHistories];
  },
};

export default messagesQuery;
